import "./Footer.scss";
import shi_icon from "../../assets/Shi_icon1.png";
import email from "../../assets/icons/email.svg";
import linkedin from "../../assets/icons/icon-linkedin.svg";
import github from "../../assets/icons/icon-github.svg";
import leetcode from "../../assets/icons/LC.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const {t} = useTranslation();
    return (
      <div id="contact" className="footer">
        <div className="footer__wrapper">
          <Link to="/">
            <img className="footer__image" src={shi_icon} alt="Shi's Profile" />
          </Link>
          <div className="footer__company">
            <h3>{t("footer.contactme")}</h3>
            <div className="footer__email">
              <img className="filter-svg" src={email} alt="email:" />
              <h4>{t("footer.email")}</h4>
            </div>
            <div className="footer__social">
              <a href="https://www.linkedin.com/in/heng-shi">
                <img src={linkedin} alt="LinkedIn" />
              </a>
              <a href="https://github.com/Sharon-SHH">
                <img className="img_github" src={github} alt="Github" />
              </a>
              <a href="https://leetcode.com/u/sharonshh/">
                <img className="icon_lc" src={leetcode} alt="Leetcode" />
              </a>
            </div>
            <p>{t("footer.copyright")}</p>
          </div>
        </div>
      </div>
    );
}

export default Footer;